import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { SignInComponent } from '../dialogs/sign-in/sign-in.component';
import { MatDialog } from '@angular/material';
import { LoginService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  constructor(
    public dialog: MatDialog,
    public api: ApiService,
    public login: LoginService
  ) {}

  print(title: string): void {
    let printContents;
    let popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <link href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" rel="stylesheet">
          <style>
          @media print {
            body * {
              color: #000;
              background: transparent;
              -webkit-print-color-adjust: exact !important;
            }
            .for-print{
              display: block;
            }
            .center-block {
              display: block;
              margin-left: auto;
              margin-right: auto;
              text-align: center;
            }
            .col-md-6 {
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
            }
            img {
              width: 50px;
              height: 50px;
            }
            .chat {
              list-style: none;
              margin: 0;
              padding: 0;
            }
            .chat li {
              margin-bottom: 10px;
              padding-bottom: 5px;
              border-bottom: 1px dotted #B3A9A9;
            }
            .chat li .chat-body p {
              margin: 0;
              color: #3c3c3c;
            }
            h4 {
              font-size: 18px;
            }
            h5 {
              font-size: 16px;
            }
          }
          </style>
        </head>
          <body onload="window.print();window.close()">
          <div class="row" style="margin: 16px 0;">
             <div class="center-block">
              <img src="https://s3-ap-southeast-2.amazonaws.com/autoscoopimages/apple-touch-icon.png" class="center-block" />
             </div>
          </div>
          <hr>
          ${printContents}
          <br><hr><br>
          </body>
      </html>`);
    popupWin.document.close();
  }

  openSignInDialog(body: string) {
    const dialogRef = this.dialog.open(SignInComponent, {
      width: '250px',
      data: { body },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== true) {
        // user data
        // name, image, uid, provider, email, token (returns  accessToken for Facebook, Google no token for linkedIn)
        const payload = {
          photo: result.image,
          firstName: result.first_name,
          lastName: result.last_name,
          email: result.email,
        };
        this.api.socialLogin(payload).subscribe(
          r => {
            this.login.save(result, r.userId);
          },
          error => {
            console.log(error);
          }
        );
      }
    });
  }
}
